const validatePresence = (value: unknown, requiredFields: string[]): string | boolean => {
  if (typeof value === 'object' && value !== null) {
    const isValid = requiredFields.every((field) => {
      const fieldValue = (value as Record<string, unknown>)[field];
      return field in value && fieldValue !== undefined && fieldValue !== null && fieldValue !== '';
    });
    return isValid ? true : 'Required';
  }
  return 'Required';
};

export default validatePresence;
